// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay{position:fixed;z-index:1000;top:0;left:0;right:0;bottom:0;background:rgba(103,117,129,0.49);opacity:0;transition:opacity 0.3s ease}.overlay--visible{opacity:1}.darwin-modal{background:#fff;padding:3rem;position:relative;width:auto;border-radius:2px}@media screen and (min-width: 576px){.darwin-modal{max-width:500px;margin:1.75rem auto}}\n", ""]);
// Exports
module.exports = exports;
